export const RAVEN_TRANSACTION_TYPE_DEF_GET = "/RavenTransactionTypeDef/GetAllRavenTransactionTypeDef"
export const RAVEN_TRANSACTION_TYPE_DEF_INSERT = "/RavenTransactionTypeDef/InsertRavenTransactionTypeDef"
export const RAVEN_TRANSACTION_TYPE_DEF_UPDATE = "/RavenTransactionTypeDef/UpdateRavenTransactionTypeDef"
export const RAVEN_TRANSACTION_TYPE_DEF_DELETE = "/RavenTransactionTypeDef/DeleteRavenTransactionTypeDef"
